//import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";

//import { useNavigation } from "@react-navigation/native";

// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
import Constants from 'expo-constants';
const { API_BASE_PATH } = Constants.expoConfig!.extra as any;
// initializing the axios instance with custom configs
console.log('we got ', API_BASE_PATH)
const api = axios.create({
  withCredentials: false,
  headers: {
    "Custom-Language": "en",
  },
  baseURL: API_BASE_PATH
});

// Optionally, you can set up interceptors 
// api.interceptors.request.use(
//   async (config) => {
//       // If you need to dynamically set headers, you can do it here
//       // For example, adding a token stored in localStorage or state:
//       const token = await AsyncStorage.getItem('@NL:token');
//       const tokenType = await AsyncStorage.getItem('@NL:token_type');
//       if (token) {
//           config.headers.Authorization = `Bearer ${token}`;
//           config.headers["token-type"] = tokenType;
//       }
//       return config;
//   },
//   (error) => {
//       // Handle error
//       return Promise.reject(error);
//   }
// );

// // Add a response interceptor
// api.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response && error.response.status === 401) {
//       // If the status is 401, redirect to the sign-in page
//       // const navigation = useNavigation();
//       // navigation.navigate('sign-in');
//     }
//     return Promise.reject(error);
//   }
// );

export default api;
